import UserToken from '@admin/tokens/user'
import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import pluralize from 'pluralize'
import lz from 'lz-string'
import React from 'react'
import qs from 'qs'

class Export extends React.Component {

  static contextTypes = {
    admin: PropTypes.object,
    flash: PropTypes.object,
    locale: PropTypes.object,
    modal: PropTypes.object,
    network: PropTypes.object
  }

  static propTypes = {
    columns: PropTypes.array,
    defaultFilter: PropTypes.object,
    defaultQuery: PropTypes.object,
    defaultSort: PropTypes.object,
    endpoint: PropTypes.string,
    entity: PropTypes.string,
    filter: PropTypes.object,
    query: PropTypes.object,
    sort: PropTypes.string
  }

  state = {
    data: {}
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleChange = this._handleChange.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    const { admin } = this.context
    return {
      title: 't(Export Data)',
      saveText: 'Export',
      onCancel: this._handleCancel,
      onChange: this._handleChange,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            { label: 't(Columns)', name: 'columns', type: 'checkboxgroup', required: true, options: this._getColumns(), defaultValue: this._getDefaults(), height: 200 },
            { label: 't(Format)', name: 'format', type: 'radiogroup', required: true, options: [
              { value: 'xlsx', text: 't(Excel)' },
              { value: 'csv', text: 't(CSV)' }
            ], defaultValue: 'xlsx' },
            { label: 't(Strategy)', name: 'strategy', type: 'radiogroup', required: true, options: [
              { value: 'download', text: 't(Download the export file)' },
              { value: 'self', text:  <span dangerouslySetInnerHTML={{ __html: `Email the export file to <strong>${admin.user.email}</strong>` }} /> },
              { value: 'user', text: 't(Email the export file to another user)' },
              { value: 'email', text: 't(Email the export file to email address)' }
            ], defaultValue: 'download' },
            ...this._getTarget()
          ]
        }
      ]
    }
  }

  _getColumns() {
    const { locale } = this.context
    const { columns } = this.props
    return columns.reduce((columns, column) => [
      ...columns,
      ...column.key === 'contact.display_name' ? [
        { key: 'contact.first_name', label: 't(First Name)' },
        { key: 'contact.last_name', label: 't(Last Name)' },
        { key: 'contact.email', label: 't(Email)' }
      ] : [column]
    ], []).map(column => ({
      value: column.key,
      text: locale.t(column.label)
    }))
  }

  _getDefaults() {
    return this._getColumns().map(column => column.value)
  }

  _getTarget() {
    const { entity } = this.props
    const { data } = this.state
    if(data.strategy === 'download') return []
    const fields = []
    if(data.strategy === 'email') {
      fields.push({ name: 'email', type: 'emailfield', required: true })
    } else if(data.strategy === 'user') {
      fields.push({ name: 'user', type: 'lookup', required: true, prompt: 't(Choose a User)', endpoint: '/api/admin/users', filter: { is_active: { $eq: true } }, valueKey: 'id', textKey: 'full_name', format: UserToken })
    }
    if(data.strategy !== 'download') {
      fields.push({ name: 'subject', type: 'textfield', required: true, defaultValue: `${_.capitalize(entity)} Export` })
      fields.push({ name: 'message', type: 'textarea', rows: 5, required: true, defaultValue: 'Here is an export' })
    }
    return [{ label: 't(Email)', type: 'segment', required: true, fields }]
  }

  _getEmail(data) {
    const { admin } = this.context
    const { email, strategy, user } = data
    if(strategy === 'self') return { value: admin.user.email, text: admin.user.email }
    if(strategy === 'user') return { value: user.email, text: user.full_name }
    if(strategy === 'email') return { value: email, text: email }
  }

  _getEncoded(data) {
    const { defaultFilter, defaultQuery, entity, filter, query, sort } = this.props
    const { columns } = data
    const stringified = qs.stringify({
      filename: pluralize(entity),
      download: true,
      ...query,
      ...defaultQuery,
      $filter: {
        ...defaultFilter || {},
        ...filter
      },
      $sort: sort,
      $page: {
        limit: 0
      },
      $select: this._getColumns().filter(column => {
        return _.includes(columns, column.value)
      }).reduce((select, item) => ({
        ...select,
        [item.text]: item.value
      }), {})
    })
    return lz.compressToEncodedURIComponent(stringified)
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handleChange(data) {
    this.setState({ data })
  }

  _handleSuccess(data) {
    if(data.strategy === 'download') return this._handleDownload(data)
    this._handleSend(data)
  }

  _handleDownload(data) {
    const { token } = this.context.admin
    const { endpoint } = this.props
    const { format } = data
    window.location.href = `${endpoint}.${format}?token=${token}&$encoded=${this._getEncoded(data)}`
    this.context.modal.close()
  }

  _handleSend(data) {
    const { format, message, subject } = data
    const { endpoint, entity } = this.props
    const email = this._getEmail(data)
    this.context.network.request({
      endpoint: '/api/admin/exports',
      method: 'POST',
      body: {
        to: email.value,
        filename: pluralize(entity),
        endpoint,
        encoded: this._getEncoded(data),
        format,
        subject,
        message
      },
      onFailure: () => this.context.flash.set('error', 't(Unable to export data)'),
      onSuccess: () => {
        this.context.flash.set('success', 't(Export file queued for delivery)')
        this.context.modal.close()
      }
    })
  }

}

export default Export
